// Developer: Ankit Gupta
/**
 * Whether Orion's conversations column is put away, shared by the conversation page and the top
 * bar's toggle (the theme draws the toggle at the start of the top bar). Kept in this browser; when
 * storage is unavailable the column is simply shown.
 */
import { useSyncExternalStore } from 'react';

const KEY = 'orion-side-collapsed';
const EVENT = 'orion-side-collapsed';

function read(): boolean {
  try { return window.localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setSideCollapsed(v: boolean) {
  try { window.localStorage.setItem(KEY, v ? '1' : '0'); } catch { /* storage is a convenience */ }
  window.dispatchEvent(new Event(EVENT));
}

function subscribe(on: () => void) {
  window.addEventListener(EVENT, on);
  window.addEventListener('storage', on);
  return () => { window.removeEventListener(EVENT, on); window.removeEventListener('storage', on); };
}

export function useSideCollapsed(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}

/** The Orion routes that show the conversations column: the list, a new conversation, one conversation. */
export const showsConversations = (path: string) => /^\/orion(\/new|\/\d+)?\/?$/.test(path);
